
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"43","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.237.198C.271.175 3.73.164 10.608.164h10.32l.995 2.314c.148.355.314.749.497 1.183.183.434.314.749.394.943.092.194.154.32.189.377h-.686l-.12-.24a5.792 5.792 0 00-.96-1.337 6.39 6.39 0 00-1.268-.96c-1.28-.777-3.086-1.24-5.418-1.389-.56-.034-2.571-.057-6.034-.068H3.511l.138.188c5.29 7.235 7.948 10.886 7.97 10.955.012.023.012.057 0 .103l-9.05 10.32c0 .011 1.205.017 3.617.017 4.857 0 7.48-.012 7.868-.035 1.566-.08 2.772-.222 3.617-.428 1.68-.412 2.995-1.177 3.943-2.297.24-.309.474-.72.703-1.234h.686c-.035.068-.395 1.04-1.08 2.914l-.994 2.657-10.303.017c-6.88 0-10.337-.011-10.372-.034-.068-.023-.103-.075-.103-.154 0-.023.012-.058.035-.103l.6-.669c.388-.457.965-1.126 1.731-2.006.766-.868 1.52-1.72 2.263-2.554 3.04-3.463 4.554-5.206 4.543-5.228 0-.012-.189-.27-.566-.772-.377-.514-.983-1.337-1.817-2.469-.823-1.142-1.56-2.16-2.211-3.05L.169.866.15.61C.151.37.18.233.237.198z","fill":"#000C1F"}}),_c('rect',{attrs:{"x":"27.503","y":"6.664","width":"15","height":"11","rx":"1.5","stroke":"#000C1F","stroke-dasharray":"4 4"}})])
          )
        }
      }
    